import { render, staticRenderFns } from "./my-course-units.vue?vue&type=template&id=77415f40&scoped=true"
import script from "./my-course-units.vue?vue&type=script&lang=ts&setup=true"
export * from "./my-course-units.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./my-course-units.vue?vue&type=style&index=0&id=77415f40&prod&scoped=true&lang=css"
import style1 from "./my-course-units.vue?vue&type=style&index=1&id=77415f40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77415f40",
  null
  
)

export default component.exports